import { useCallback, useState } from "react";

import { isUnitTest } from "@citrine/configuration";

import { useResizeObserver } from "./use-resize-observer";

const DEFAULT_SIZE = isUnitTest
  ? { width: 1, height: 1 }
  : { width: 0, height: 0 };

function getSize(el: HTMLElement | null) {
  if (!el) {
    return DEFAULT_SIZE;
  }
  const boundingBox = el.getBoundingClientRect?.();
  return {
    width: boundingBox?.width || el?.offsetWidth || 0,
    height: boundingBox?.height || el?.offsetHeight || 0,
  };
}

export function useElementSize(element: HTMLElement | null) {
  const [size, setSize] = useState(getSize(element));

  const onResize = useCallback(() => setSize(getSize(element)), [element]);
  useResizeObserver(element, onResize);

  return size;
}
